/*!
 * @pixi/canvas-display - v6.0.4
 * Compiled Tue, 11 May 2021 18:00:23 UTC
 *
 * @pixi/canvas-display is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
import{Container as a,DisplayObject as r}from"@pixi/display";a.prototype._renderCanvas=function(a){},a.prototype.renderCanvas=function(a){if(this.visible&&!(this.worldAlpha<=0)&&this.renderable){this._mask&&a.maskManager.pushMask(this._mask),this._renderCanvas(a);for(var r=0,s=this.children.length;r<s;++r)this.children[r].renderCanvas(a);this._mask&&a.maskManager.popMask(a)}},r.prototype.renderCanvas=function(a){};
//# sourceMappingURL=canvas-display.min.js.map
